<div>
<div class="row base-margin-bottom">
    <div class="col-md-12 col-lg-12">
           <div class="btn btn--link prev" (click)="onPrevious($event)">Back</div>
    </div>
</div>
<router-outlet></router-outlet>
</div>

